import { render } from "./SkillComponent.vue?vue&type=template&id=018f5b53"
import script from "./SkillComponent.vue?vue&type=script&lang=js"
export * from "./SkillComponent.vue?vue&type=script&lang=js"

import "./SkillComponent.vue?vue&type=style&index=0&id=018f5b53&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__